export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/34633123150"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-all duration-300 z-50 cursor-pointer group"
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-line text-3xl text-white"></i>
      <span className="absolute right-20 bg-white text-[#2C3E50] font-['Satoshi'] text-sm font-semibold py-2 px-4 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
        ¿Necesitas ayuda?
      </span>
    </a>
  );
}
